import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import React from 'react';
import DOMPurify from 'dompurify';
import theme from '@/themes/morganstanley';

export type HeaderProps = {
  bannerTopHTML: string;
  bannerBottomHTML?: string;
  showBottomBanner: boolean;
};
const HeaderWrapper = styled('header')({
  textAlign: 'center',
});
export const Header = (props: HeaderProps) => {
  const { bannerTopHTML, bannerBottomHTML, showBottomBanner } = props;

  const sanatizedBannerTop = DOMPurify.sanitize(bannerTopHTML);

  return (
    <>
      <HeaderWrapper aria-label="tax guide header">
        <div id="hd">
          <div id="hd_top" data-testid={'banner-top'}>
            <div
              dangerouslySetInnerHTML={{
                __html: sanatizedBannerTop,
              }}
            />
          </div>
          {bannerBottomHTML && showBottomBanner && (
            <div id="hd_bottom" data-testid={'banner-bottom'}>
              <Box
                sx={{
                  textAlign: 'center',
                  fontSize: theme.typography.custom_banner_font.fontSize,
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(bannerBottomHTML),
                }}
              />
            </div>
          )}
        </div>
      </HeaderWrapper>
    </>
  );
};
